export default "__VITE_ASSET__DSbFFEQ8__"